import React, { useState } from 'react'
import { Checkbox } from 'antd'
import BulkActionStatus from '../Actions/BulkActionStatus'
import { Button, Dropdown, Icon, Menu } from 'antd'

function RuleCreateBatchHeader(props) {
    const { toggleSelectAll, selectedItems = [], isSelectedAll, listRule = [], reset } = { ...props }
    const [action, setAction] = useState('')

    const handleMenuClick = ({ key }) => {
        setAction(key)
    }

    const resetAction = () => {
        setAction('')
        toggleSelectAll(false)
    }

    const renderAction = () => {
        switch (action) {
            case 'bulkIdsAction1':
                return <BulkActionStatus listRule={listRule} selectedItems={selectedItems} resetAction={resetAction} reset={reset} />
            default:
                return ''
        }
    }
    const menu = (
        <Menu onClick={handleMenuClick} selectable={false}>
            <Menu.Item className='ant-dropdown-menu-item' key='bulkIdsAction1'>
                On/Off status
            </Menu.Item>
        </Menu>
    )

    return (
        <thead className={`thead-light RuleCreateBatchHeader `}>
            {selectedItems.length > 0 ?
                <tr >
                    <th className='selectAll position-relative' style={{ maxWidth: 40 }}>
                        <Checkbox checked={isSelectedAll} onChange={e => toggleSelectAll(e.target.checked)} />
                    </th>
                    <th colSpan={12} className="position-relative">
                        <div className="d-flex align-items-center">
                            <Dropdown overlay={menu} trigger={['click']}>
                                <Button>Actions <Icon type='down' /></Button>
                            </Dropdown>
                            <div className='ml-3 font-weight-300'>
                                <span>Bạn đã chọn <strong>{selectedItems.length}</strong> items.</span>
                            </div>
                            {renderAction()}
                        </div>
                    </th>
                </tr> :
                <tr>
                    <th className='selectAll position-relative'>
                        <Checkbox checked={isSelectedAll} onChange={e => toggleSelectAll(e.target.checked)} />
                    </th>
                    <th className='Priority'>Priority</th>
                    <th className='Partner'>Partner</th>
                    <th className='Sku'>SKU</th>
                    <th className='OrderTag'>Order tag</th>
                    <th className='Store'>Store</th>
                    <th className='ruleType'>Loại rule</th>
                    <th className='OnlyPackagename'>Only package</th>
                    <th className='OnlyStore'>Only store</th>
                    <th className='Schedule'>Schedule</th>
                    {/* <th className='RuleType'>Khổ NVL</th> */}
                    <th className='Variant'>Variant</th>
                    <th className='Status'>Status</th>
                    <th className='Action'>Action</th>
                </tr>
            }
        </thead>
    )
}

export default RuleCreateBatchHeader